module.exports = __webpack_public_path__ + "img/ohl-leuven.e0e99025.png";